<template>
  <div v-if="!loading">
    <pinned-message />
    <liveflight-header />
    <main class="main">
      <router-view />
    </main>
    <liveflight-prefooter />
    <liveflight-footer />
    <modal-notification ref="modal_notification" />
    <toast-notification ref="toast_notification" />
    <b-alert :show="VUE_APP_MODE !== 'production'" id="debug-alert">
      <b>SITO DEMO</b>
      <br />
      vai su <a :href="prodUrl">{{ prodName }}</a>
    </b-alert>
  </div>
</template>

<script>
import Vue from 'vue';
import { app_config } from '@/config';
import PinnedMessage from '@/components/blocks/pinned-message';
import ModalNotification from '@/components/modal-notification';
import ToastNotification from '@/components/toast-notification';
import Header from '@/components/header/header';
import Footer from '@/components/footer/footer';
import Prefooter from '@/components/blocks/prefooter';
export default {
  name: 'app',
  metaInfo: {
    title: process.env.VUE_APP_SITE_PAYOFF,
    titleTemplate: '%s - ' + process.env.VUE_APP_SITE_TITLE,
    meta: [
      {
        vmid: 'metaTitle',
        name: 'Title',
        content: 'Prenota online voli. Semplice e sicuro!',
      },
      {
        vmid: 'metaDescription',
        name: 'Description',
        content:
          'Prenota online i tuoi voli in modo semplice e soprattutto sicuro. ' +
          process.env.VUE_APP_SITE_TITLE +
          ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni',
      },
      {
        vmid: 'metaKeywords',
        name: 'Keywords',
        content:
          process.env.VUE_APP_SITE_TITLE +
          ', viaggi online, online travel booking, online travel agency, agenzia viaggi online, prenotazione online viaggi, viaggi welfare aziendale, viaggi welfare, viaggi promozioni, viaggi marketing, viaggi viaggi programmi fedeltà, viaggi programma fedeltà, viaggi loyalty program, catalogo a premi viaggi',
      },
      {
        vmid: 'metaAbstract',
        name: 'abstract',
        content:
          process.env.VUE_APP_SITE_TITLE +
          'è un servizio di prenotazione voli online pensato per gli utenti del welfare aziendale. ' +
          process.env.VUE_APP_SITE_TITLE +
          ' offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi',
      },
      {
        vmid: 'metaClassification',
        name: 'Classification',
        content: 'Commercial',
      },
      { vmid: 'metaResourceType', name: 'resource-type', content: 'document' },
      { vmid: 'metaDistribution', name: 'Distribution', content: 'Global' },
      { vmid: 'metaRating', name: 'Rating', content: 'General' },
      { vmid: 'metaLanguage', name: 'Language', content: 'IT' },
      { vmid: 'metaOwner', name: 'Owner', content: 'Salabam SRL' },
      {
        vmid: 'ogTitle',
        property: 'og:title',
        content: 'Prenota voli online in tempo reale',
      },
      {
        vmid: 'ogSiteName',
        name: 'site_name',
        content: process.env.VUE_APP_SITE_PAYOFF + ' ' + process.env.VUE_APP_SITE_TITLE,
      },
      { vmid: 'ogType', name: 'og:type', content: 'website' },
      { vmid: 'ogUrl', name: 'og:url', content: window.location.href },
      {
        vmid: 'ogImage',
        name: 'og:image',
        content: process.env.VUE_APP_SITE_HOST + 'assets/' + process.env.VUE_APP_OG_IMAGE,
      },
      { vmid: 'ogImageWidth', name: 'og:image:width', content: '512' },
      { vmid: 'ogImageHeight', name: 'og:image:height', content: '512' },
      {
        vmid: 'ogDescription',
        name: 'og:description',
        content:
          'Prenota voli online in modo semplice e soprattutto sicuro. ' +
          process.env.VUE_APP_SITE_TITLE +
          ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni',
      },
      {
        vmid: 'dcTitle',
        name: 'DC.title',
        lang: 'it',
        content:
          'Prenota voli online in modo semplice e soprattutto sicuro. ' +
          process.env.VUE_APP_SITE_TITLE +
          ', soluzioni di travel booking per il welfare aziendale, per i piani loyalty, per il marketing i concorsi e le promozioni',
      },
      { vmid: 'dcCreator', name: 'DC.creator', content: 'Salabam SRL' },
      {
        vmid: 'dcSubject',
        name: 'DC.subject',
        lang: 'it',
        content:
          process.env.VUE_APP_SITE_TITLE +
          ';viaggi online;online travel booking;online travel agency;agenzia viaggi online;prenotazione online viaggi;viaggi welfare aziendale;viaggi welfare;viaggi promozioni;viaggi marketing;viaggi viaggi programmi fedeltà;viaggi programma fedeltà;viaggi loyalty program;catalogo a premi viaggi',
      },
      {
        vmid: 'dcDescription',
        name: 'DC.description',
        lang: 'it',
        content:
          process.env.VUE_APP_SITE_TITLE +
          'è un servizio di prenotazione voli online pensato per gli utenti del welfare aziendale. ' +
          process.env.VUE_APP_SITE_TITLE +
          ' offre soluzioni di online travel booking per i programmi fedeltà, per le promozioni e i concorsi',
      },
      {
        vmid: 'dcType',
        name: 'DC.type',
        scheme: 'DCTERMS.DCMIType',
        content: 'Text',
      },
      { vmid: 'dcFormat', name: 'DC.format', content: 'text/html' },
      {
        vmid: 'dcIdentifier',
        name: 'DC.identifier',
        scheme: 'DCTERMS.URI',
        content: process.env.VUE_APP_SITE_HOST,
      },
      {
        vmid: 'dcLanguage',
        name: 'DC.language',
        scheme: 'DCTERMS.RFC1766',
        content: 'IT',
      },
      {
        vmid: 'robots',
        name: 'robots',
        content: process.env.VUE_APP_META_ROBOTS,
      },
    ],
  },
  components: {
    'pinned-message': PinnedMessage,
    'modal-notification': ModalNotification,
    'toast-notification': ToastNotification,
    'liveflight-header': Header,
    'liveflight-footer': Footer,
    'liveflight-prefooter': Prefooter,
  },
  data() {
    return {
      VUE_APP_MODE: process.env.VUE_APP_MODE,
      prodUrl: process.env.VUE_APP_PROD_URL,
      prodName: process.env.VUE_APP_PROD_NAME,
    };
  },
  computed: {
    loading: {
      get() {
        return this.$store.state.loading;
      },
      set(value) {
        this.$store.commit('loading', value);
      },
    },
  },
  beforeMount() {
    this.app_config = app_config;
    let _this = this;
    let wait_router_interval = setInterval(function () {
      // aspetto che il router carichi la rotta attuale, altrimenti app_config non riesce a leggere l'eventuale token in get
      if (_this.$route.name == null) return;
      clearInterval(wait_router_interval);
      _this.app_config().then(() => {
        _this.loading = false;
      });
    }, 100);
  },
  mounted() {
    let _this = this;

    // ex gotNotification
    window.eventBus.$on('got_modal_notification', (data) => {
      _this.$refs.modal_notification.handle_notification(data);
    });

    window.eventBus.$on('got_toast_notification', (data) => {
      _this.$refs.toast_notification.handle_notification(data);
    });

    // loginModal
    let wait_auth_interval = setInterval(() => {
      if (!Vue.prototype.$config) return; // async auth in progress
      clearInterval(wait_auth_interval);
      if (_this.$route.name !== 'homepage') return; // homepage only
      const login_modal = Vue.prototype.$config.guiSettings.loginModal;
      if (!login_modal) return;
      _this.$refs.modal_notification.handle_notification(login_modal);
    }, 100);
    // loginModal
  },
  created() {},
  destroyed() {},
  methods: {},
};
</script>

<style lang="scss">
@import 'scss/_app.scss';
.main {
  margin-bottom: 100px;
}
</style>
